import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from './icons/SearchIcon';

export default function Search({ onSearch, keyword }) {
  return (
    <div className="w-full sm:max-w-lg flex items-cemter relative">
      <span className="absolute top-1/2 -translate-y-1/2 pl-3 flex items-center text-zinc-500 dark:text-zinc-400">
        <SearchIcon />
      </span>
      <input
        type="text"
        placeholder="Search threads.."
        className="w-full border-2 border-zinc-500 dark:border-zinc-400 pl-10 rounded-lg px-3 py-2 text-base outline-none text-zinc-500 dark:text-zinc-400 bg-white dark:bg-zinc-800 placeholder:italic focus:outline-none focus:border-cyan-500 dark:focus:border-cyan-600 focus:ring-cyan-500 dark:focus:ring-cyan-600 lg:focus:ring-1"
        value={keyword}
        onChange={onSearch}
      />
    </div>
  );
}

Search.propTypes = {
  onSearch: PropTypes.func.isRequired,
  keyword: PropTypes.string,
};

Search.defaultProps = {
  keyword: '',
};
